import { render } from "./StorageBrowser.vue?vue&type=template&id=fe27339e"
import script from "./StorageBrowser.vue?vue&type=script&lang=js"
export * from "./StorageBrowser.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__